import { render, staticRenderFns } from "./ActiveMail.vue?vue&type=template&id=25c4154a"
import script from "./ActiveMail.vue?vue&type=script&lang=js"
export * from "./ActiveMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports